<template>
  <div class="about  app-bg">
    <div class="about-header">
      <p>信息公示</p>
    </div>
    <div class="announcement-container-layout">
    <v-container class="pa-0">
      <v-layout class="layout-list" column>
        <left-nav @handleList="handleList" :list="list"/>
        <zhaoBiao v-if="showId == 1001"/>
        <zhongbiao v-if="showId == 1002" />
        <qingshui v-if="showId == 1003"></qingshui>
        <qingshuizb v-if="showId == 1004"/>
        <hlwyxxcsqgzs v-if="showId == 1008"/>
        <imageComponent
                v-if="showId == 1005"
                title="慧择暂停合作通知函"
                imageUrl="https://qihuibao.oss-cn-beijing.aliyuncs.com/comps/hlw-hzzthztzh.png"
        />
        <imageComponent
                v-if="showId == 1006"
                title="世纪保险经纪合作中止通知函"
                imageUrl="https://qihuibao.oss-cn-beijing.aliyuncs.com/comps/hlw-sjbxjjhzzztzh.png"
        />
        <imageComponent
                v-if="showId == 1007"
                title="君石保险经合作中止通知函"
                imageUrl="https://qihuibao.oss-cn-beijing.aliyuncs.com/comps/jsbxjjhzzztzh.png"
        />
      </v-layout>
    </v-container>
    </div>
  </div>
</template>

<script>
import leftNav from "@/views/announcement/leftNav"
import zhaoBiao from "@/views/announcement/components/1001"
import zhongbiao from "@/views/announcement/components/1002"
import qingshui from "@/views/announcement/components/1003"
import qingshuizb from "@/views/announcement/components/1004"
import hlwyxxcsqgzs from "@/views/announcement/components/1008"
import imageComponent from "@/views/announcement/components/imageComponent"
export default {
  data() {
    return {
      list:[
        {
          id:1008,
          label:'关于防范保险从业人员违规销售非保险金融产品的风险提示',
        },
        {
          id:1004,
          label:'关于防范新型电信网络诈骗的风险提示',
        },
        // {
        //   id:1006,
        //   label:'世纪保险经纪合作中止通知函',
        // },
        // {
        //   id:1005,
        //   label:'慧择暂停合作通知函',
        // },
        // {
        //   id:1004,
        //   label:'清水县防返贫保险试点项目中标公告',
        // },
        // {
        //   id:1003,
        //   label:'清水县防返贫保险试点项目招标公告',
        // },
        // {
        //   id:1002,
        //   label:'张家川回族自治县乡村振兴局防返贫保险项目中标公告',
        // },
        // {
        //   id:1001,
        //   label:'张家川回族自治县乡村振兴局防返贫保险项目招标公告',
        // },
      ],
      showId:1008,
    };
  },

  components:{
    leftNav,
    zhaoBiao,
    zhongbiao,
    qingshui,
    qingshuizb,
    imageComponent,
    hlwyxxcsqgzs
  },
  methods:{
    handleList(id){
      this.showId = id;
    }
  }

};
</script>
<style lang="scss">
// @media only screen and (min-width: 1280px){
//   .about{
//     .container {
//       max-width: 900px !important;
//     }
//   }
// }
.about {

  h3 {
    text-align: center;
  }
  .layout-list{
    position: relative;
  }
}
article p {
  text-indent: 2em;
  font-size: 16px;
  color: #666;
}

.about-header {
  width: 100%;
  height: 377px;
  background: url("/images/about/about-bg-new.png") no-repeat center center;
  background-size: cover;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }
}

@media screen and (max-width: 600px) {
  .about-header p{
    font-size:28px ;
  }


  article,.about-img,.contact{
    padding: 0 15px;
  }
}
  @media screen and (max-width: 960px) and (min-width: 540px) {
    .announcement-container-layout {
      .pa-0 {
        width: 60%;

        h2 {
          font-size: 30px;
        }
      }
    }
  }
@media screen and (max-width: 540px) {
  .announcement-container-layout {
    .pa-0 {
      width: 50%;

      h2 {
        font-size: 20px;
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 960px) {
  .announcement-container-layout {
    .pa-0 {
      width: 68%;

      h2 {
        font-size: 30px;
      }
    }
  }
}
@media screen and (min-width: 1280px) and (max-width: 1500px){
  .announcement-container-layout {
    .pa-0 {
      width: 75%;
    }
  }
}
</style>
